import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail, Image } from 'lucide-react';
import { Button } from '../components/ui/button';
import Logo from '../assets/logo.svg';

const LandingPage = () => {
  const navigate = useNavigate();

  const handleContactClick = () => {
    window.location.href = 'mailto:info@one-ev.de';
  };

  const handleReferencesClick = () => {
    navigate('/referenzen');
  };

  return (
    <div className="min-h-screen bg-white flex flex-col">
      {/* Main Content */}
      <main className="flex-1 flex flex-col items-center justify-center px-6 py-16">
        {/* Logo */}
        <div className="mb-16 lg:mb-24">
          <img 
            src={Logo} 
            alt="1EV Logo" 
            className="h-32 w-auto md:h-40 lg:h-48 transition-transform duration-300 hover:scale-105"
          />
        </div>

        {/* Hero Section */}
        <div className="max-w-4xl mx-auto text-center space-y-8">
          {/* Main Headline */}
          <h1 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold leading-tight">
            <span className="text-[#FF5722]">E-Mobility</span>{' '}
            <span className="text-black">Deutschlandweit</span>
          </h1>

          {/* Decorative underline */}
          <div className="flex justify-center">
            <div className="w-16 h-1 bg-[#FF5722] rounded-full"></div>
          </div>

          {/* Tagline */}
          <div className="space-y-4 pt-8">
            <h2 className="text-xl md:text-2xl lg:text-3xl font-semibold text-black">
              <span className="font-bold">Full-Service</span>{' '}
              <span className="font-normal">aus einer Hand:</span>
            </h2>

            {/* Service Description */}
            <p className="text-base md:text-lg lg:text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed">
              Von der <span className="text-[#FF5722] font-medium">Planung</span>, über den{' '}
              <span className="text-[#FF5722] font-medium">Bau</span>, die{' '}
              <span className="text-[#FF5722] font-medium">Elektroarbeiten</span>, das{' '}
              <span className="text-[#FF5722] font-medium">Management</span> bis zur{' '}
              <span className="text-[#FF5722] font-medium">Übergabe</span>.
            </p>
          </div>

          {/* CTA Buttons */}
          <div className="pt-8 flex flex-col gap-4 justify-center items-center">
            <Button
              onClick={handleContactClick}
              className="bg-[#FF5722] hover:bg-[#E64A19] text-white font-medium text-base md:text-lg px-8 py-6 rounded-md transition-all duration-300 hover:shadow-lg hover:scale-105 active:scale-95"
            >
              <Mail className="mr-2 h-5 w-5" />
              Kontakt aufnehmen
            </Button>

            <Button
              onClick={handleReferencesClick}
              className="bg-white hover:bg-gray-50 text-[#FF5722] border-2 border-[#FF5722] font-medium text-base md:text-lg px-8 py-6 rounded-md transition-all duration-300 hover:shadow-lg hover:scale-105 active:scale-95"
            >
              <Image className="mr-2 h-5 w-5" />
              Unsere Referenzen
            </Button>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="py-8 px-6 border-t border-gray-300">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-600">
            {/* Copyright */}
            <div className="text-center md:text-left">
              <p>© 2026 ONE-EV GmbH. Alle Rechte vorbehalten.</p>
            </div>

            {/* Contact Email */}
            <div className="flex items-center gap-2">
              <Mail className="h-4 w-4" />
              <a 
                href="mailto:info@one-ev.de" 
                className="hover:text-[#FF5722] transition-colors duration-200"
              >
                info@one-ev.de
              </a>
            </div>
          </div>

          {/* Impressum */}
          <div className="mt-4 text-xs text-gray-500 text-center md:text-left">
            <p>
              <span className="font-semibold">IMPRESSUM:</span> ONE-EV GmbH | Celiusstraße 2, D-14532 Kleinmachnow | 
              Geschäftsführer: Jan Mikolajczak | Amtsgericht Potsdam, HRB 41680 P | USt.-Ident-Nr. DE660224399
            </p>
          </div>
        </div>
      </footer>

    </div>
  );
};

export default LandingPage;